import React, { useState } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import styled from 'styled-components';
import i18n from '../../i18n';
import { getDomainAndPort } from 'api/Utils';
import { black } from 'utils/style/colors';

interface ILogoLoadingProps {
  src?: string;
}

const LoadingText = styled.span`
  font-size: 1rem;
  color: ${black};
`;

const LottyLoading: React.FC<ILogoLoadingProps> = ({ src }) => {
  const domain = getDomainAndPort();

  const [path, _] = useState(
    domain.domainFeatures?.enableWebdaLoading
      ? `${domain.protocolDomain}/assets/webda_loading.json`
      : `${domain.protocolDomain}/assets/loading.json`
  );

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Player
        src={src ?? path}
        background="transparent"
        speed={1}
        style={{ width: '300px', height: '300px', margin: 'auto' }}
        loop
        controls
        autoplay
      />
      <LoadingText>
        {i18n.t('loading', { ns: 'general' }) as string}
      </LoadingText>
    </div>
  );
};

export default React.memo(LottyLoading);
